import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import services from "../../../../services/services";
import { Urls } from "../../../../services/Urls";
import { ToastContext } from "../../../../context/ToastContext";
import { useGlobalFields } from "../Fields/useGlobalFields";
import _ from "underscore";

export const useScreenConfiguration = ({ filterValues, setFilterValues }) => {
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const { rowData } = useGlobalFields({ filterValues, setFilterValues });
    const [loader, setLoader] = useState({})
    const [fieldData, setFieldData] = useState([]);
    const [fieldValues, setFieldValues] = useState({})
    const [option, setOption] = useState({});
    const multiSelectRef = useRef(null);
    const [visible, setVisible] = useState({})
    const [tabList, setTabList] = useState([])

    useEffect(() => {
        (filterValues?.config?.screen_id && filterValues?.apiCall) && getScreenConfigruationDetails();
    }, [filterValues?.apiCall])

    useEffect(() => {
        const remainingFields = rowData?.filter(rowItem => !fieldData.some(fieldItem => fieldItem?.custom_field_id === rowItem?.custom_field_id));
        setOption({ fields: remainingFields?.map((item) => ({ ...item, custom_field_name: `${item?.custom_field_name} (${item?.field_type})` })) });
    }, [rowData, fieldData, fieldValues?.search])

    const columns = [
        {
            key: "field",
            label: "Field",
            style: { width: "50%" },
            render: (row) => (
                <div className="d-flex align-items-center gap-2">
                    {row.isPrimary && (
                        <span className="badge bg-secondary-subtle text-secondary border-0 fw-bold"
                            style={{ fontSize: '7px', padding: '2px 4px' }}>
                            LOCKED
                        </span>
                    )}
                    <span className=" " >{row.custom_field_name}</span>
                </div>
            )
        },
        {
            key: "type",
            label: "Data type",
            style: { width: "30%" },
            render: (row) => (
                row?.schema_type && <span className=" bg-light text-muted fw-bold text-capitalize px-2 py-1 my-2"
                    style={{ fontSize: '10px' }}>
                    {row?.schema_type}
                </span>
            )
        },
        {
            key: "actions",
            label: "Action",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "20%" },
            render: (row) => (
                <div className="d-flex justify-content-center gap-1">
                    <FontAwesomeIcon icon="fa-solid fa-trash" className="text-danger c-pointer" onClick={() => setVisible((prev) => ({ ...prev, delete: true, id: row?.custom_field_id }))} />
                </div>
            )
        }
    ];

    const formJson = [
        {
            label: "Name",
            name: "tab",
            col: "12",
            type: "text",
            required: true,
        },
    ]

    const filterData = useMemo(() =>
        _.filter(fieldData, (item) => item?.tab_id === filterValues?.activeTab?.tab_id),
        [fieldData, filterValues?.activeTab]
    );

    const getScreenConfigruationDetails = async () => {
        try {
            const payload = {
                "screen_id": filterValues?.config?.screen_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("GETSCREENCONFIGURATIONDETAILS"), payload);
            if (!res?.body?.error_status) {
                const tabs = res?.body?.data?.screen_configuration_tab_details || []
                setFieldData(res?.body?.data?.screen_configuration_tab_fields_details)
                if (_.isEmpty(filterValues?.activeTab)) {
                    setFilterValues((prev) => ({ ...prev, activeTab: tabs[0] }))
                }
                setTabList(tabs)
            } else {
                setFieldData([])
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const upsertFieldInScreen = async (isDelete) => {
        try {
            const existingIds = _.pluck(_.filter(fieldData, item => item?.tab_id === filterValues?.activeTab?.tab_id) || [], "custom_field_id");
            const selectedIds = fieldValues?.field || [];
            const mergedIds = [...new Set([...existingIds, ...selectedIds])];
            if (!isDelete && _.isEmpty(selectedIds)) {
                showInfo("Info", "No fields selected");
                return;
            }
            const payload = {
                "tab_id": filterValues?.activeTab?.tab_id,
                "screen_id": filterValues?.config?.screen_id,
                "screen_configuration_customfield_ids": isDelete ? visible?.id?.toString() : mergedIds?.toString() || "",
                "is_deleted": isDelete || false
            }


            const res = await services.getInvokeRemote("POST", Urls("UPSERTSCREENCONFIGURATIONFIELDS"), payload);
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message)
                if (isDelete) {
                    setFieldData(prevData => prevData.filter(item => item?.custom_field_id !== visible?.id));
                    setVisible((prev) => ({ ...prev, delete: false, id: null }))
                } else {
                    setFieldValues((prev) => ({ isChange: false, field: [] }))
                    getScreenConfigruationDetails()
                }
            } else {
                showError("Error", res.body.message);
            }
        } catch (error) {
            console.error("error::", error)
        }
    }

    const screenCrudTab = async (isDelete) => {
        try {
            setLoader({ btn: true })
            if ((!fieldValues?.isChange || visible?.row?.tab_name?.trim() === fieldValues?.tab?.trim()) && !isDelete) {
                showInfo("info", "No changes made.");
                return;
            }
            if (!fieldValues?.tab?.trim() && !isDelete) {
                showInfo("Info", "Please enter tab name.");
                return;
            }
            let names = _.pluck(tabList, "tab_name")?.map(item => item?.toLowerCase()?.trim());
            if (!visible?.isNew) {
                names = _.filter(names, item => item !== filterValues?.activeTab?.tab_name?.toLowerCase()?.trim());
            }
            if (fieldValues?.tab?.trim() && names?.includes(fieldValues?.tab?.toLowerCase()?.trim()) && !isDelete) {
                showInfo("Info", "This tab name is already exist.");
                return;
            }
            const payload = {
                "tab_id": visible?.isNew ? 0 : filterValues?.activeTab?.tab_id || 0,
                "screen_id": filterValues?.config?.screen_id,
                "tab_name": fieldValues?.tab || "",
                "is_deleted": isDelete || false
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTSCREENCONFIGURATIONTAB"), payload)
            if (!res?.body?.error_status) {
                showSuccess('Sucess', res.body.message);
                setFieldValues((prev) => ({ ...prev, tab: "", isChange: false }))
                setVisible({ show: false, isNew: false, row: {} });
                if (isDelete) {
                    setTabList(prevData =>
                        prevData.filter(item => item?.tab_id !== filterValues?.activeTab?.tab_id)
                    );
                    setVisible({ tabDelete: false });
                } else if (!filterValues?.activeTab || !filterValues?.activeTab?.tab_id || visible?.tab) {
                    getScreenConfigruationDetails()
                } else {
                    setTabList(prevData => prevData.map(item =>
                        item.tab_id === filterValues?.activeTab?.tab_id
                            ? {
                                ...item,
                                tab_name: fieldValues?.tab
                            }
                            : item
                    ));
                }
            } else {
                showError("Error", res.body.message);
            }
        } catch (error) {
            console.error("error::", error)
        } finally {
            setLoader({ btn: false })
        }
    }

    const filteredFields = useMemo(() => {
        if (!fieldValues?.search?.trim()) return option;
        return {...option, fields: option?.fields?.filter((item) => item?.custom_field_name?.toLowerCase()?.includes(fieldValues?.search.toLowerCase()))};
    }, [fieldValues?.search, option?.fields, rowData])

    return { columns, fieldData, option: filteredFields, multiSelectRef, formJson, tabList, setTabList, fieldValues, setFieldValues, screenCrudTab, upsertFieldInScreen, filterData, loader, visible, setVisible }
}